import { render, staticRenderFns } from "./finishFee.vue?vue&type=template&id=4aa950c8"
import script from "./finishFee.vue?vue&type=script&lang=js"
export * from "./finishFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports